import {
  actions,
  getComponentTypeByIdAsync,
  getComponentTypesLookupsAsync,
  getComponentTypesByCollectionComponentIdAsync,
  createComponentTypeAsync,
  getComponentTypesDatatableAsync,
  getComponentTypesByCollectionComponentTypeIdAsync,
  getComponentTypeByIdMultilingualAsync,
  createComponentTypeMultilingualAsync,
  editComponentTypeMultilingualAsync,
} from './slices';

export const ComponentTypesActions = {
  ...actions,
  getComponentTypeByIdAsync,
  getComponentTypesLookupsAsync,
  getComponentTypesByCollectionComponentIdAsync,
  createComponentTypeAsync,
  getComponentTypesDatatableAsync,
  getComponentTypesByCollectionComponentTypeIdAsync,
  getComponentTypeByIdMultilingualAsync,
  createComponentTypeMultilingualAsync,
  editComponentTypeMultilingualAsync,
};

export * from './thunkHandlers';
